import { PayloadAction } from '@reduxjs/toolkit';

import { RightbarState, RightTab } from 'editor/src/store/editorModules/rightbar/types';

const setActiveRightbarReducer = (state: RightbarState, action: PayloadAction<RightTab>) => {
  state.activeTab = action.payload;
};

export default setActiveRightbarReducer;
